export default __webpack_public_path__ + "static/media/RAS.51124612.png";